import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { FormProvider, useFormContext } from "react-hook-form";
import { AddEmissionContext } from "../../../../../../contexts/AddEmissionContext";
import { common, input, overview } from "../../../../../../i18n";
import NumericField from "../../../../../../components/input/NumericField";

const AddWastewater = () => {
  const { t } = useTranslation([common, overview, input], {
    nsMode: "fallback",
  });

  const stepTwoForm = useFormContext();

  const { isDisabledAuxInput } = AddEmissionContext();

  return (
    <FormProvider {...stepTwoForm}>
      <Grid item xs={12} md={6}>
        <NumericField
          size="small"
          name="amount"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          disabled
          label={t("amount-of-organic-loading")}
          placeholder={t("to-be-calculated")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux4"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("Amount-of-Sludge")}
          placeholder={t("Amount-of-Sludge")}
          fullWidth
          disabled={isDisabledAuxInput}
          InputProps={{
            endAdornment: (
              <Typography
                variant="text1"
                color={"var(--dark)"}
                style={{
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              >
                kgCOD
              </Typography>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux2"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("BOD-COD-Value")}
          placeholder={t("Wastewater-Unit-Conversion-Desc")}
          info={t("Wastewater-Unit-Conversion-Helper")}
          fullWidth
          disabled={isDisabledAuxInput}
          InputProps={{
            endAdornment: (
              <Typography
                variant="text1"
                color={"var(--dark)"}
                style={{
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              >
                kgCH4/m3
              </Typography>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NumericField
          required={!isDisabledAuxInput}
          size="small"
          name="aux3"
          control={stepTwoForm.control}
          allowNegative={false}
          decimalScale={2}
          label={t("Amount-of-Wastewater")}
          placeholder={t("Amount-of-Wastewater")}
          fullWidth
          disabled={isDisabledAuxInput}
          InputProps={{
            endAdornment: (
              <Typography
                variant="text1"
                color={"var(--dark)"}
                style={{
                  userSelect: "none",
                  pointerEvents: "none",
                }}
              >
                m3
              </Typography>
            ),
          }}
        />
      </Grid>
    </FormProvider>
  );
};

export default AddWastewater;
